'use client';

import { useUserContext } from '@/context/user';
import clsx from 'clsx';
import TrackOrderForm from '../TrackOrderForm/trackOrderForm';
import TrackOrderSignIn from '../TrackOrderSignIn';

const TrackOrderPage = () => {
  const [{ isSignedIn }] = useUserContext();

  return (
    <div className='mx-auto max-w-[1100px] px-3 py-10 lg_px-0 lg_pb-20 lg_pt-[60px]'>
      <h1 className='font-teko-medium text-[30px] leading-none lg_text-[40px]'>TRACK YOUR ORDER</h1>
      <div
        className={clsx(
          'mt-5 flex flex-col gap-y-5 lg_mt-[60px] lg_flex-row  lg_gap-x-[50px]',
          isSignedIn && 'justify-center',
        )}
      >
        <div className='max-w-[500px] lg_flex-1'>
          <h2 className='font-roboto-medium text-[18px] leading-none lg_text-xl lg_leading-7'>
            Track Without Signing In
          </h2>
          <TrackOrderForm />
        </div>
        {isSignedIn ? null : (
          <>
            <div className='h-[1px] bg-e0e0e0 lg_h-auto lg_w-[1px]'></div>
            <div className='lg_flex-1'>
              <h2 className='font-roboto-medium text-[18px] leading-none lg_text-xl lg_leading-7'>Sign In to Track</h2>
              <TrackOrderSignIn />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TrackOrderPage;
